const skills = {
    title: "Skills Development",
    mdcontent: `
    
## Skills Development


This page provides an overview of how to introduce and monitor skills, and their development, with an introduction to proper technique of fundamental skills. The section below will give an example of what you should be looking at in theory to fulfil a skill.
\n
Fundamental skills are key to making a good hockey player and the basis to good contact. Even professional players focus on improving their skating, puck control and shooting, and they should not be disregarded when teaching and advancing players skills. In the BUIHA, clubs have a varying amount of ice time which consequently affect a lot on how much time you have to focus on skills. Even if your club does not get more than one session a week - try to focus some time particularly at the beginning of the season on these fundamentals and incorporate drills through the season that also tap in to keep the development ongoing.
\n
Fundamental skills in building contact can be divided into the following categories:

![Graph](https://buiha.org.uk/assets/img/education/fig-3.png)

To help fulfil these skills we have developed a framework that can be used to assess skill levels when players join the club, and aid in creating a pathway for new players to make sure they learn all the fundamentals. Think of these as a "check-list" you can use to mark where a player is at with their skill. 

**Skating Fundamentals**
![Graph](https://buiha.org.uk/assets/img/education/fig-4.png)

**Skating Fundamentals 2**
![Graph](https://buiha.org.uk/assets/img/education/fig-5.png)

**Positioning & Angling Fundamentals**
![Graph](https://buiha.org.uk/assets/img/education/fig-6.png)

**Key Principles of Stick Lifts**
![Graph](https://buiha.org.uk/assets/img/education/fig-7.png)

**Key Principles of Stick Press**
![Graph](https://buiha.org.uk/assets/img/education/fig-8.png)

**Key Principles of Poke Checks**
![Graph](https://buiha.org.uk/assets/img/education/fig-9.png)

**Key principles of Sweep Checks**
![Graph](https://buiha.org.uk/assets/img/education/fig-10.png)

**Key principles of Contact**
![Graph](https://buiha.org.uk/assets/img/education/fig-11.png)

**Key principles of Body-Checking**
![Graph](https://buiha.org.uk/assets/img/education/fig-12.png)

`,
    };
export default skills;